'use client';
import React, { useState } from 'react';

const creatures = [
  {
    id: 'creature-humpback',
    name: 'Humpback Whale',
    emoji: '🐋',
    desc: 'A whale friend is passing by, singing a gentle song.',
    detail: 'Humpback whales can sing for hours! Their songs travel thousands of kilometres through the ocean.',
    depth: '200m deep',
    distance: '2.1 km away',
    color: 'border-kid-whale/40 bg-kid-whale/10',
    accentColor: 'text-kid-dolphin',
    glowColor: 'rgba(38,70,83,0.4)',
    sound: '300 Hz',
  },
  {
    id: 'creature-dolphin',
    name: 'Bottlenose Dolphins',
    emoji: '🐬',
    desc: 'A playful pod of dolphins is clicking and chatting nearby.',
    detail: 'Dolphins use clicking sounds to find their way and talk to each other — like a secret language!',
    depth: '40m deep',
    distance: '0.8 km away',
    color: 'border-kid-dolphin/40 bg-kid-dolphin/10',
    accentColor: 'text-kid-dolphin',
    glowColor: 'rgba(76,201,240,0.2)',
    sound: '12 kHz',
  },
  {
    id: 'creature-fish',
    name: 'Sardine School',
    emoji: '🐟',
    desc: 'Thousands of tiny fish swimming together like a shimmering cloud.',
    detail: 'Fish swim in schools to stay safe. When they turn together, it looks like a silver ribbon dancing in the water!',
    depth: '25m deep',
    distance: '1.4 km away',
    color: 'border-kid-fish/40 bg-kid-fish/10',
    accentColor: 'text-kid-fish',
    glowColor: 'rgba(244,162,97,0.15)',
    sound: '—',
  },
  {
    id: 'creature-plankton',
    name: 'Glowing Plankton',
    emoji: '✨',
    desc: 'Tiny creatures lighting up the water like tiny stars.',
    detail: 'Bioluminescent plankton glow when the water moves. On dark nights, the ocean can sparkle blue and green!',
    depth: '5m deep',
    distance: '0.3 km away',
    color: 'border-kid-plankton/40 bg-kid-plankton/10',
    accentColor: 'text-kid-plankton',
    glowColor: 'rgba(185,251,192,0.15)',
    sound: '—',
  },
];

export default function CreatureCards() {
  const [active, setActive] = useState<string | null>(null);

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {creatures?.map((c) => (
        <button
          key={c?.id}
          onClick={() => setActive(active === c?.id ? null : c?.id)}
          className={`rounded-2xl border p-5 text-left transition-all duration-300 hover:scale-[1.02] active:scale-95 ${c?.color} ${active === c?.id ? 'ring-2 ring-kid-blue/40' : ''}`}
          style={{ boxShadow: active === c?.id ? `0 0 24px ${c?.glowColor}` : 'none' }}
        >
          <div className="text-4xl mb-3">{c?.emoji}</div>
          <p className={`text-sm font-bold mb-1 ${c?.accentColor}`}>{c?.name}</p>
          <p className="text-xs text-foreground/80 leading-relaxed mb-3">
            {active === c?.id ? c?.detail : c?.desc}
          </p>
          <div className="flex items-center justify-between text-[10px] text-muted-foreground pt-2 border-t border-border/30">
            <span>{c?.depth}</span>
            <span>{c?.distance}</span>
          </div>
          {c?.sound !== '—' && (
            <div className="mt-2 flex items-center gap-1.5">
              <div className="flex gap-0.5">
                {[1, 2, 3, 4, 5]?.map((bar) => (
                  <div
                    key={`bar-${c?.id}-${bar}`}
                    className={`rounded-full ${c?.accentColor?.replace('text-', 'bg-')} ocean-breathing`}
                    style={{
                      width: 2,
                      height: 4 + bar * 2,
                      opacity: 0.7,
                      animationDelay: `${bar * 0.15}s`,
                    }}
                  />
                ))}
              </div>
              <span className={`text-[10px] ${c?.accentColor}`}>{c?.sound}</span>
            </div>
          )}
        </button>
      ))}
    </div>
  );
}